export default __webpack_public_path__ + "static/media/6.4d65be1b.png";